import { InlineFeedbackDialogResponseProps } from '../actions/logInlineFeedbackDialogResponse';

export interface CategoriesToLog {
    fdcn: string;
    fdscn?: string[];
}

export default function getCategoriesToLog(
    dialogResponse: InlineFeedbackDialogResponseProps
): CategoriesToLog[] {
    let categoriesDataLogging: CategoriesToLog[] = [];

    if (dialogResponse.subCategories && dialogResponse.subCategories.size > 0) {
        const subCategoriesAsJsonMap = dialogResponse.subCategories.toJSON();

        for (const [key, value] of Object.entries(subCategoriesAsJsonMap)) {
            const selectedSubCategories: string[] = value.map(category => category.logString);
            if (selectedSubCategories.length > 0) {
                categoriesDataLogging.push({ fdcn: key, fdscn: selectedSubCategories });
            }
        }
    } else if (dialogResponse.inlineFeedbackResponseCategories) {
        categoriesDataLogging = dialogResponse.inlineFeedbackResponseCategories.map(category => {
            return { fdcn: category };
        });
    }
    return categoriesDataLogging;
}
